<div class="flex flex-col min-h-screen bg-website-primary-background" style="max-width: 100vw">

  <header class="container flex-initial flex flex-col sm:flex-row items-center">

    <!-- LOGO -->
    <div class="flex gap-6 sm:gap-8 items-center pt-8 sm:pt-0">
      <img src="../../../../assets/logo/mindpop-logo.svg" height="48" width="48" class="h-14 w-14 sm:h-12 sm:w-12"
        alt="Mindpop Logo" />
      <img src="../../../../assets/logo/mindpop-font.svg" height="32" class="h-9 sm:h-8 mt-1" alt="Mindpop Schrift" />
    </div>

    <!-- ACTION PORTAL -->
    <div class="flex-auto hidden sm:block">
      @if (isLoggedIn()) {
      <div class="text-right mt-2">
        Hey {{ user()?.firstName }}, willst du dich <a class="underline cursor-pointer" (click)="logout()">abmelden</a>?
      </div>
      }
    </div>
  </header>

  <!-- CONTENT -->
  <section class="container flex-auto flex flex-col">

    <div class="flex flex-col flex-auto">
      <!-- FORBIDDEN -->
      @if (isForbidden === true) {
      <h3 class="pt-10 mt-24">{{'General.You do not have access to this item' | translate }}</h3>
      <p>{{'General.In most cases, the item you wanted to access requires permissions that you do not have.'
        | translate }}<br>
        {{
        'General.If this is a mistake, please contact your company administrator to ask for the required permissions.'
        | translate }}
      </p>
      }

      <!-- NOT FOUND -->
      @if (notFound === true) {
      <h3>{{'General.The item you were looking for could not be found' | translate }}</h3>
      <p>{{'General.In most cases, the item you wanted to access does not exist or has been deleted.' | translate }}
      </p>
      }

      <!-- CONTENT-->
      @if (isForbidden === false && notFound === false) {
      <div class="flex-grow enlarge-child flex flex-col">
        <router-outlet></router-outlet>
      </div>
      }

    </div>

  </section>

  <footer
    class="flex-initial flex flex-col sm:flex-row w-full  m-auto sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1024px] xl:max-w-[1280px] 2xl:max-w-[1536px] px-6 pt-12 pb-52 sm:pt-0 sm:pb-4 text-center sm:text-left gap-4 sm:gap-0">

    <!-- ACTION PORTAL -->
    <div class="flex-auto block sm:hidden">
      @if (isLoggedIn()) {
      <div class="text-center sm:text-right mb-8 sm:mt-2">
        Hey {{ user()?.firstName }}, willst du dich <a class="underline cursor-pointer" (click)="logout()">abmelden</a>?
      </div>
      }
    </div>

    <!-- LEFT CONTENT -->
    <div class="flex-auto">
      <span>Copyright by Mindpop</span>
      <span>|</span>
      <span>Learnfox GmbH</span>
    </div>

    <!-- RIGHT CONTENT -->
    <div class="flex-initial flex gap-4 justify-center sm:justify-end">
      <a class="underline" href="https://help.support.mindpopapp.com/servicedesk/customer/portal/3/group/11/create/47"
        target="_blank">Abo kündigen</a>
      <a class="underline" href="https://mindpopapp.com/impressum" target="_blank">Impressum</a>
      <a class="underline" href="https://mindpopapp.com/datenschutz" target="_blank">Datenschutz</a>
      <a class="underline" href="https://mindpopapp.com/agb" target="_blank">AGB</a>
      <a class="underline" href="https://mindpopapp.com/faq" target="_blank">FAQ</a>
    </div>
  </footer>

</div>